import React, { useState } from 'react';
import AppIcon from '../../../components/AppIcon';

const MatchScoreTooltip = ({ matchPercentage, matchFactors, breakdown }) => {
  const [isVisible, setIsVisible] = useState(false);

  const getMatchColor = (percentage) => {
    if (percentage >= 90) return 'text-success';
    if (percentage >= 75) return 'text-warning';
    if (percentage >= 60) return 'text-primary';
    return 'text-error';
  };

  const getMatchBadgeColor = (percentage) => {
    if (percentage >= 90) return 'bg-success-50 border-success-200';
    if (percentage >= 75) return 'bg-warning-50 border-warning-200';
    if (percentage >= 60) return 'bg-primary-50 border-primary-200';
    return 'bg-error-50 border-error-200';
  };

  const formatBreakdownScore = (score) => {
    return Math.round(score || 0);
  };

  return (
    <div className="relative inline-block">
      <div
        className={`flex items-center space-x-1 cursor-help`}
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
      >
        <AppIcon name="Target" size={16} className={getMatchColor(matchPercentage || 0)} />
        <span className={`text-sm font-medium ${getMatchColor(matchPercentage || 0)}`}>
          {matchPercentage || 0}% match
        </span>
      </div>

      {isVisible && (breakdown || (matchFactors && matchFactors.length > 0)) && (
        <div className="absolute z-50 left-0 mt-2 w-80 bg-white border border-gray-200 rounded-lg shadow-lg p-4">
          <div className="mb-3">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm font-medium text-gray-700">Overall Match</span>
              <span className={`text-lg font-bold ${getMatchColor(matchPercentage || 0)}`}>
                {matchPercentage || 0}%
              </span>
            </div>
            <div className={`w-full h-2 rounded-full border ${getMatchBadgeColor(matchPercentage || 0)}`}>
              <div
                className={`h-full rounded-full transition-all duration-300 ${
                  (matchPercentage || 0) >= 90 ? 'bg-success' :
                  (matchPercentage || 0) >= 75 ? 'bg-warning' :
                  (matchPercentage || 0) >= 60 ? 'bg-primary' : 'bg-error'
                }`}
                style={{ width: `${matchPercentage || 0}%` }}
              />
            </div>
          </div>

          {breakdown && (
            <div className="mb-3">
              <h4 className="text-sm font-medium text-gray-700 mb-2">Score Breakdown</h4>
              <div className="space-y-2 text-xs">
                <div className="flex justify-between">
                  <span className="text-gray-600">Skills Match (40%)</span>
                  <span className="font-medium">{formatBreakdownScore(breakdown.skillsScore)}%</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Experience (25%)</span>
                  <span className="font-medium">{formatBreakdownScore(breakdown.experienceScore)}%</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Rate Compatibility (20%)</span>
                  <span className="font-medium">{formatBreakdownScore(breakdown.rateScore)}%</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Rating/Quality (10%)</span>
                  <span className="font-medium">{formatBreakdownScore(breakdown.ratingScore)}%</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Location (5%)</span>
                  <span className="font-medium">{formatBreakdownScore(breakdown.locationScore)}%</span>
                </div>
              </div>
            </div>
          )}

          {matchFactors && matchFactors.length > 0 && (
            <div>
              <h4 className="text-sm font-medium text-gray-700 mb-2">Key Factors</h4>
              <div className="space-y-1">
                {matchFactors.map((factor, index) => (
                  <div key={index} className="flex items-start space-x-2 text-xs">
                    <AppIcon 
                      name={factor.includes('Excellent') || factor.includes('Strong') || factor.includes('Perfect') ? 'CheckCircle' : 
                            factor.includes('Limited') || factor.includes('gap') || factor.includes('concerns') || factor.includes('mismatch') ? 'AlertTriangle' : 
                            'Info'} 
                      size={12} 
                      className={
                        factor.includes('Excellent') || factor.includes('Strong') || factor.includes('Perfect') ? 'text-success mt-0.5' : 
                        factor.includes('Limited') || factor.includes('gap') || factor.includes('concerns') || factor.includes('mismatch') ? 'text-warning mt-0.5' : 
                        'text-primary mt-0.5'
                      } 
                    />
                    <span className="text-gray-600">{factor}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MatchScoreTooltip;
